import * as React from "react";

export default function DocumentTitle(props: { children: string }) {
  React.useEffect(() => {
    document.title = props.children;
  }, [props.children]);

  return null;
}
